// extracted by mini-css-extract-plugin
module.exports = {"historyContainer":"history_historyContainer__f-W1k","history":"history_history__1dCVz"};